import { inject, Injectable } from '@angular/core';
import { PharmacyChainForSidebarFragment } from '@generated/graphql';
import { PharmacyService } from '@services/pharmacy.service';
import { StorageType, Store } from '@services/store';
import { intersection, sortBy } from 'lodash';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ChainsStore extends Store<PharmacyChainForSidebarFragment> {
  protected static storageType: StorageType = 'session';
  private readonly pharmacyService = inject(PharmacyService);

  protected getDataSource(key: string): Observable<any> {
    return this.pharmacyService.getPharmacyChain({ npi: key });
  }

  getChains(chainNpis: string[]): Observable<PharmacyChainForSidebarFragment[]> {
    const compare = intersection(chainNpis, this.keys());
    if (compare.length === chainNpis.length) {
      return of(chainNpis).pipe(
        map(items => items.map(item => this.store[item])),
        map(items => sortBy(items, 'name')),
      );
    }
    return this.pharmacyService.getPharmacyChainsForSidebar({ filter: { npis: { value: chainNpis } }, page: { take: 9999 } }).pipe(
      map(items => items.edges.map(edge => edge.node).filter(item => !!item)),
      tap(items => items.forEach(item => this.set(item.npi, item))),
    );
  }
}
